import PropTypes from 'prop-types';
import React from 'react';
import { Navigate, Route, Routes, useMatch } from 'react-router-dom';
import Entry from 'react/signups/card/modules/survey/entry/Entry';
import Manage from 'react/signups/card/modules/survey/manage/Manage';
import ClientRoles from 'react/signups/card/modules/survey/roles/client/Roles';
import FamilyRoles from 'react/signups/card/modules/survey/roles/family/Roles';
import FamilyThanks from 'react/signups/card/modules/survey/thanks/family/Thanks';
import TrustDetails from 'react/signups/card/modules/survey/trust_details/family/TrustDetails';
import Trustee from 'react/signups/card/modules/survey/trustee/Trustee';
import { USER_TYPES } from 'react/signups/card/recipes/constants';

export default function SurveyRoutes({ userType, defaultPath, passThroughParams }) {
  // This catches any hard refresh within the survey and starts the user over
  if (!useMatch(defaultPath) && userType === '') {
    return <Navigate replace to={defaultPath} />;
  }

  return (
    <Routes>
      <Route element={<Entry {...passThroughParams} />} exact path="/entry" />
      <Route element={<Manage {...passThroughParams} />} exact path="/manage" />
      <Route element={<ClientRoles {...passThroughParams} />} exact path="/roles" />
      <Route element={<FamilyRoles {...passThroughParams} />} exact path="/card_for" />
      <Route element={<Trustee {...passThroughParams} />} exact path="/trustee" />
      <Route element={<TrustDetails {...passThroughParams} />} exact path="/trust_details" />
      {userType === USER_TYPES.FAMILY && (
        <Route element={<FamilyThanks {...passThroughParams} />} exact path="/thanks" />
      )}
      <Route element={<Navigate replace to={defaultPath} />} path="/*" />
    </Routes>
  );
}

SurveyRoutes.propTypes = {
  defaultPath: PropTypes.string.isRequired,
  userType: PropTypes.string.isRequired,
  passThroughParams: PropTypes.object.isRequired,
  setMdWidthCard: PropTypes.func,
};
